import { render, staticRenderFns } from "./UiRippleInk.vue?vue&type=template&id=4eb9a7d2"
import script from "./UiRippleInk.vue?vue&type=script&lang=js"
export * from "./UiRippleInk.vue?vue&type=script&lang=js"
import style0 from "./UiRippleInk.vue?vue&type=style&index=0&id=4eb9a7d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports